import React from "react";
import { useLocation } from "react-router-dom";
import ProductsCardContainer from "../../components/ProductsCardContainer/ProductsCardContainer";
import "./Produse.css";

const Produse = ({ onCartUpdate }) => {
  // Acceptă prop-ul onCartUpdate
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search); // Extrage query parameters
  const category = searchParams.get("category"); // Obține valoarea pentru category

  return (
    <div style={{ padding: 30 }}>
      <h1>
        {category
          ? `Produse - ${category.charAt(0).toUpperCase() + category.slice(1)}`
          : "Toate Produsele"}
      </h1>
      <ProductsCardContainer category={category} onCartUpdate={onCartUpdate} />{" "}
      {/* Transmite prop-ul mai departe */}
    </div>
  );
};

export default Produse;
